import { FormValues } from "../../../../Interface/scheduler/form";
import ContactUsPayloadInterface from "../../../../service/model/ContactUsPayloadInterface";

const ContactUsPayload = (formValues, formConfig, correlationID) => {
  const { secondarySource = "" }: FormValues = formValues;
  const primarySource = sessionStorage.getItem("primarySource");

  const howDidYouHearAboutUs =
    primarySource && secondarySource
      ? `${primarySource}: ${secondarySource}`
      : primarySource || "";

  const customLeadSourceDefault = sessionStorage.getItem(
    "customLeadSourceDefault"
  );

  const contactUsPayload: ContactUsPayloadInterface = {
    franchiseWebLocationId: 0,
    conceptId: Number(formConfig?.conceptid),
    isLocalized: false,
    firstName: formValues.fname as string,
    lastName: formValues.lname as string,
    zipCode: formValues.zipcode as string,
    email: formValues.email as string,
    phone: formValues.phone as string,
    isNewCustomer: "",
    signUpForUpdates: true,
    isTest: process.env.NODE_ENV === "prod" ? false : true,
    optIn: formValues.optIn ? (formValues.optIn as boolean) : false,
    city: formValues.city as string,
    state: formValues.state as string,
    country: formValues.countryCode as string,
    address: formValues.address1
      ? (formValues.address1 as string)
      : (formValues.address as string),
    address2: formValues.address2 as string,
    legacyLeadTableId: 0,
    legacyLeadTableId2: 0,
    correlationId: correlationID,
    conceptCode: formConfig?.conceptCode,
    emailOptOut: formValues.emailOptOut
      ? (formValues.emailOptOut as boolean)
      : false,
    howDidYouHearAboutUs: howDidYouHearAboutUs
      ? howDidYouHearAboutUs
      : customLeadSourceDefault,
  };

  return contactUsPayload;
};
export default ContactUsPayload;
